export class FeatureExtractor {
    register(extractors = []) {
        this.extractors = this.extractors.concat(extractors);
    }
    extract(editorState, rawContentState) {
        const features = [];
        for (const extractor of this.extractors){
            const feature = extractor(editorState, rawContentState);
            if (feature) {
                features.push(feature);
            }
        }
        return features;
    }
    constructor(){
        this.extractors = [];
    }
}
